import { render, staticRenderFns } from "./ToolbarSidebarContent.vue?vue&type=template&id=88a53f8c&scoped=true&lang=html"
import script from "./ToolbarSidebarContent.vue?vue&type=script&lang=js"
export * from "./ToolbarSidebarContent.vue?vue&type=script&lang=js"
import style0 from "./ToolbarSidebarContent.vue?vue&type=style&index=0&id=88a53f8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88a53f8c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAppBarNavIcon } from 'vuetify/lib/components/VAppBar';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VAppBarNavIcon,VToolbar,VToolbarTitle})
